import { InjectionToken } from '@angular/core';

export const CORS_SITE_DOMAIN = new InjectionToken<any>('CORS_SITE_DOMAIN');
export const SYSTEM_DOMAIN = new InjectionToken<any>('SYSTEM_DOMAIN');
export const HASH_SECRET_KEY = new InjectionToken<any>('HASH_SECRET_KEY');
export const AUTH_API_BASE_URL = new InjectionToken<any>('API_BASE_URL');
export const SLACK_API_ENDPOINT = new InjectionToken<any>('SLACK_API_ENDPOINT');
export const BATCH_API_ENDPOINT = new InjectionToken<any>('BATCH_API_ENDPOINT');
export const ELASTIC_APP_SEARCH_SEARCH_KEY = new InjectionToken<any>('ELASTIC_APP_SEARCH_SEARCH_KEY');
export const ELASTIC_APP_SEARCH_ENDPOINT = new InjectionToken<any>('ELASTIC_APP_SEARCH_ENDPOINT');